import type { ChatRoomListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoType } from './chatRoomListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoType';

/**
 * 채팅방 기본 정보
 */
export type ChatRoomListResponsePageAllOfThreeContentItemBasicInfoAllOfTwo = {
  name?: string;
  type?: ChatRoomListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoType;
};
